var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPushPinFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.418 13l-6.684 6.707c.57 1.583.806 4.236-1.649 7.5a1.992 1.992 0 01-1.459.793h-.14a2.001 2.001 0 01-1.416-.586l-6.032-6.039-5.33 5.333a1 1 0 01-1.414-1.415l5.332-5.329-6.037-6.037a2 2 0 01.162-2.973c3.178-2.564 6.22-2.06 7.55-1.642l6.7-6.724a2 2 0 012.83 0l7.585 7.585A2 2 0 0129.418 13z"
  })));
}
export default SvgPushPinFill;